module.exports = __webpack_public_path__ + "static/img/chevronsY.d562232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chevronsY.png
// module id = Ocao
// module chunks = 1